<div class="mjml-editor">
  <div class="editor-layout">
    <!-- MJML Code Editor -->
    <div class="editor-panel">
      <div class="panel-header">
        <div class="header-left">
          <h4 class="panel-title">
            <svg viewBox="0 0 24 24" class="icon">
              <path d="M9.4,16.5L4.9,12L9.4,7.5L8,6.1L2.1,12L8,17.9L9.4,16.5M14.6,16.5L19.1,12L14.6,7.5L16,6.1L21.9,12L16,17.9L14.6,16.5Z" />
            </svg>
            MJML Template
          </h4>
          <!-- Theme Switcher in Header -->
          <div class="theme-selector" *ngIf="availableThemes.length > 0">
            <select class="theme-select" [value]="theme?.id || ''" (change)="onThemeSelectChange($event)" [disabled]="disabled">
              <option value="">Select theme...</option>
              <option *ngFor="let t of availableThemes" [value]="t.id">{{ t.name }}</option>
            </select>
          </div>
        </div>

        <div class="panel-actions">
          <!-- MJML Component Buttons -->
          <button type="button" class="action-btn" (click)="insertMjmlSnippet(sectionSnippet)" title="Insert Section">
            <svg viewBox="0 0 24 24" class="icon">
              <path d="M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z" />
            </svg>
            Section
          </button>

          <button type="button" class="action-btn" (click)="insertMjmlSnippet(textSnippet)" title="Insert Text">
            <svg viewBox="0 0 24 24" class="icon">
              <path
                d="M18.5,4L19.66,8.35L18.7,8.61C18.25,7.74 17.79,7.17 17.26,6.9C16.73,6.63 16.05,6.5 15.26,6.5H13.5V16.5C13.5,17.24 13.74,17.79 14.21,18.15C14.68,18.5 15.42,18.75 16.42,18.9V19.5H9.28V18.9C10.28,18.75 11.03,18.5 11.5,18.15C11.97,17.79 12.21,17.24 12.21,16.5V6.5H10.45C9.66,6.5 8.97,6.63 8.45,6.9C7.92,7.17 7.46,7.74 7,8.61L6.05,8.35L7.2,4H18.5Z"
              />
            </svg>
            Text
          </button>

          <button type="button" class="action-btn" (click)="insertMjmlSnippet(buttonSnippet)" title="Insert Button">
            <svg viewBox="0 0 24 24" class="icon">
              <path
                d="M12,2A2,2 0 0,1 14,4C14,4.74 13.6,5.39 13,5.73V7H14A7,7 0 0,1 21,14H22A1,1 0 0,1 23,15V18A1,1 0 0,1 22,19H21A7,7 0 0,1 14,26H10A7,7 0 0,1 3,19H2A1,1 0 0,1 1,18V15A1,1 0 0,1 2,14H3A7,7 0 0,1 10,7H11V5.73C10.4,5.39 10,4.74 10,4A2,2 0 0,1 12,2Z"
              />
            </svg>
            Button
          </button>

          <button type="button" class="action-btn" (click)="insertMjmlSnippet(imageSnippet)" title="Insert Image">
            <svg viewBox="0 0 24 24" class="icon">
              <path d="M8.5,13.5L11,16.5L14.5,12L19,18H5M21,19V5C21,3.89 20.1,3 19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19Z" />
            </svg>
            Image
          </button>

          <button type="button" class="action-btn" (click)="insertMjmlSnippet(dividerSnippet)" title="Insert Divider">
            <svg viewBox="0 0 24 24" class="icon">
              <path d="M19,13H5V11H19V13Z" />
            </svg>
            Divider
          </button>

          <button type="button" class="action-btn" (click)="insertMjmlSnippet(spacerSnippet)" title="Insert Spacer">
            <svg viewBox="0 0 24 24" class="icon">
              <path d="M19,17H5V15H19V17M19,10H5V8H19V10Z" />
            </svg>
            Spacer
          </button>

          <button type="button" class="action-btn" (click)="insertMjmlSnippet(columnsSnippet)" title="Insert Columns">
            <svg viewBox="0 0 24 24" class="icon">
              <path d="M11,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H11V3M13,3V21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3H13Z" />
            </svg>
            Columns
          </button>

          <button type="button" class="action-btn" (click)="insertMjmlSnippet(heroSnippet)" title="Insert Hero">
            <svg viewBox="0 0 24 24" class="icon">
              <path d="M5,4H19A2,2 0 0,1 21,6V18A2,2 0 0,1 19,20H5A2,2 0 0,1 3,18V6A2,2 0 0,1 5,4M5,8V12H11V8H5M13,8V12H19V8H13M5,14V18H11V14H5M13,14V18H19V14H13Z" />
            </svg>
            Hero
          </button>

          <!-- Variables Dropdowns -->
          <div class="dropdown-group">
            <select
              class="variable-select"
              (change)="insertThemeVariable($any($event.target).value); $any($event.target).value = ''"
              [disabled]="disabled"
              *ngIf="getThemeVariables().length > 0"
              title="Insert theme variable"
            >
              <option value="">Theme Variables</option>
              <option *ngFor="let variable of getThemeVariables()" [value]="variable.key">
                {{ variable.display }}
              </option>
            </select>

            <select
              class="variable-select"
              (change)="insertComponentVariable($any($event.target).value); $any($event.target).value = ''"
              [disabled]="disabled"
              *ngIf="getComponentVariables().length > 0"
              title="Insert component variable"
            >
              <option value="">Component Variables</option>
              <option *ngFor="let variable of getComponentVariables()" [value]="variable.key">
                {{ variable.display }}
              </option>
            </select>
          </div>

          <!-- Utility Buttons -->
          <button type="button" class="action-btn format-btn" (click)="formatCode()" title="Format Code">
            <svg viewBox="0 0 24 24" class="icon">
              <path
                d="M8,3A2,2 0 0,0 6,5V9A2,2 0 0,1 4,11H3V13H4A2,2 0 0,1 6,15V19A2,2 0 0,0 8,21H10V19H8V14A2,2 0 0,0 6,12A2,2 0 0,0 8,10V5H10V3M16,3A2,2 0 0,1 18,5V9A2,2 0 0,0 20,11H21V13H20A2,2 0 0,0 18,15V19A2,2 0 0,1 16,21H14V19H16V14A2,2 0 0,1 18,12A2,2 0 0,1 16,10V5H14V3H16Z"
              />
            </svg>
            Format
          </button>

          <button type="button" class="action-btn refresh-btn" (click)="refreshPreview()" title="Refresh Preview">
            <svg viewBox="0 0 24 24" class="icon">
              <path
                d="M17.65,6.35C16.2,4.9 14.21,4 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20C15.73,20 18.84,17.45 19.73,14H17.65C16.83,16.33 14.61,18 12,18A6,6 0 0,1 6,12A6,6 0 0,1 12,6C13.66,6 15.14,6.69 16.22,7.78L13,11H20V4L17.65,6.35Z"
              />
            </svg>
            Refresh
          </button>
        </div>
      </div>
      <div class="editor-container">
        <div #editorContainer class="codemirror-container"></div>
      </div>
      <div class="editor-help">
        <p>
          <strong>MJML Tips:</strong>
          Use <code>{{ '{{' }}component.variableName{{'}}'}}</code> for variables. Start with <code>&lt;mj-section&gt;</code> or <code>&lt;mj-wrapper&gt;</code>.
        </p>
      </div>
    </div>

    <!-- Preview Panel -->
    <div class="preview-panel">
      <div class="panel-header">
        <h4 class="panel-title">
          <svg viewBox="0 0 24 24" class="icon">
            <path
              d="M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9M12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17M12,4.5C7,4.5 2.73,7.61 1,12C2.73,16.39 7,19.5 12,19.5C17,19.5 21.27,16.39 23,12C21.27,7.61 17,4.5 12,4.5Z"
            />
          </svg>
          Email Preview
        </h4>
        <div class="preview-info" *ngIf="theme">
          <span class="theme-name">{{ theme.name }}</span>
        </div>
      </div>

      <!-- Loading State -->
      <div class="preview-loading" *ngIf="isLoading">
        <div class="spinner"></div>
        <p>Rendering MJML...</p>
      </div>

      <!-- Error State -->
      <div class="preview-error" *ngIf="previewError && !isLoading">
        <div class="error-icon">
          <svg viewBox="0 0 24 24">
            <path d="M13,13H11V7H13M13,17H11V15H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" />
          </svg>
        </div>
        <h4>MJML Error</h4>
        <p>{{ previewError }}</p>
      </div>

      <!-- Preview Content -->
      <div class="preview-content" *ngIf="!isLoading && !previewError">
        <div class="preview-frame">
          <div class="email-preview" [innerHTML]="renderedHtml"></div>
        </div>
      </div>

      <!-- Empty State -->
      <div class="preview-empty" *ngIf="!isLoading && !previewError && !renderedHtml">
        <div class="empty-icon">
          <svg viewBox="0 0 24 24">
            <path d="M20,8L12,13L4,8V6L12,11L20,6M20,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V6C22,4.89 21.1,4 20,4Z" />
          </svg>
        </div>
        <h4>Start Writing MJML</h4>
        <p>Begin typing MJML code to see the preview</p>
      </div>
    </div>
  </div>
</div>
